import React from 'react';
import './common.css'


type I_Star = {
  rating: number;
};

const Star = ({ selected = false }) => (
  <span>
   <span className="star"><i className={`fas fa-star star_size_small ${selected ? 'star_color':'star_color_gray'}`}></i></span>
  </span>
);

const StarRating: React.FC<I_Star> = ({ rating }) => {
  const ratings = [...Array(5)];
  const filledStars = Math.floor(rating);

  return (
    <div className="rating_img">
      {ratings.map((_, index) => (
        <Star key={index} selected={filledStars > index} />
      ))}
    </div>
  );
};

export default StarRating;
